<script setup>
// The member's "play by" date on a ladder with the inactivity rule, shown just
// under the action strip. Red once half the period or less is left.
import {playByLine, playByUrgent, playByHint} from '~/utils/ladderPlayBy';

const props = defineProps({
  ladder: {type: Object, required: true},
  team: {type: Object, default: null},
});

const line = computed(() => playByLine(props.ladder, props.team));
const urgent = computed(() => playByUrgent(props.ladder, props.team));
const hint = computed(() => playByHint(props.ladder));
</script>

<template>
  <!-- Client only: the date is written in the reader's own time zone. -->
  <client-only>
    <div v-if="line" class="tl-card lpb" :class="{'lpb--urgent': urgent}" data-test="ladder-play-by">
      <div class="lpb-ic"><v-icon size="20" icon="mdi-timer-sand"/></div>
      <div class="flex-fill min-w-0">
        <div class="lpb-title">{{ line }}</div>
        <div v-if="hint" class="lpb-sub">{{ hint }}</div>
      </div>
    </div>
  </client-only>
</template>

<style scoped>
.lpb {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.lpb-ic {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  background: rgba(var(--v-theme-on-surface), 0.06);
  color: rgba(var(--v-theme-on-surface), 0.7);
}

.lpb-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.lpb-sub {
  font-size: 0.8rem;
  color: rgba(var(--v-theme-on-surface), 0.62);
}

.lpb--urgent {
  border-color: rgba(var(--v-theme-error), 0.45);
  background: rgba(var(--v-theme-error), 0.05);
}

.lpb--urgent .lpb-ic {
  background: rgba(var(--v-theme-error), 0.12);
  color: rgb(var(--v-theme-error));
}

.lpb--urgent .lpb-title {
  color: rgb(var(--v-theme-error));
}
</style>
